export default __webpack_public_path__ + "static/customdev1-73317b45bc1ce026bb0a206f2381c34e.png";